import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  Modal,
  Tooltip,
  // IconButton,
  // TextField,
  Typography,
} from "@mui/material"
import useStyles from "./useStyles"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { getFirmsCustomer } from "../../../../redux/actions/clients"
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined"
import InfoIcon from "@mui/icons-material/Info"
import CloseIcon from "@mui/icons-material/Close"
import DoneAllIcon from "@mui/icons-material/DoneAll"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
import { EditableField } from "../../Components/EditableField"
import {
  getAllSubsDelegationVE,
  updateSubsDelegationVE,
} from "../../../../redux/actions/eventanilla"
import BreadcrumbsComponent from "../../Breadcrumbs/Breadcrumbs"
import { getStatusByCode } from "../../../EVentanilla/Home/utils/statusConfig"
import { AcceptDelegationButton } from "../../../../components/AcceptDelegationButton/AcceptDelegationButton"
import {
  getApplicationInstanceEAuthz,
  getOrganizationAccess,
} from "../../../../redux/actions/eAuthz"
import ReportOutlinedIcon from "@mui/icons-material/ReportOutlined"
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined"

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  height: 225,
  bgcolor: "white",
  p: 3,
  borderRadius: "8px",
  boxShadow: "0px 0px 4px rgba(36, 55, 143, 0.4)",
  textAlign: "center",
}
const isDateToday = (dateString) => {
  if (!dateString) return false
  const date = new Date(dateString)
  const today = new Date()

  return (
    date.getUTCDate() === today.getUTCDate() &&
    date.getUTCMonth() === today.getUTCMonth() &&
    date.getUTCFullYear() === today.getUTCFullYear()
  )
}

export const ClientDetails = () => {
  const { cuit } = useParams()
  const dispatch = useDispatch()
  const classes = useStyles()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [loadingChipModule, setLoadingChipModule] = useState(true)
  const formData = useSelector(
    (state) => state?.eventanilla?.suscribersDelegation?.data?.data?.[0],
  )

  const [clientName, setClientName] = useState("")
  const [clientNote, setClientNote] = useState("")
  const [subscriptionDelId, setSubscriptionDelId] = useState(null)
  const [localFormData, setLocalFormData] = useState(null)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [isEnabledModule, setisEnabledModule] = useState(false)

  const data = useSelector(
    (state) => state?.clients.firmsCustomerData?.data || "",
  )
  const updateClientState = useSelector((state) => state?.eventanilla?.data)
  const hasData = data && data.length > 0
  const client = data?.[0]

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        await dispatch(getAllSubsDelegationVE(cuit))
        await dispatch(getFirmsCustomer(cuit))
      } catch (error) {
        console.error("Error cargando datos:", error)
      } finally {
        setLoading(false)
      }
    }

    if (cuit) {
      fetchData()
    }
  }, [cuit, dispatch, updateClientState?.success])

  useEffect(() => {
    if (formData) {
      setClientName(formData.customerSuborganizationName || "")
      setClientNote(formData.delegationNotes || "")
      setSubscriptionDelId(formData.subscriptionDelegationId || null)
    }
  }, [formData])

  useEffect(() => {
    if (localFormData?.customerSuborganizationCuit === cuit) {
      const isAccepted =
        localFormData.subscriptionStatus === "DELEGATION-ACCEPTED"
      const isAcceptedToday = isDateToday(
        localFormData.accessDelegationDateTime,
      )
      setSubscriptionDelId(localFormData.subscriptionDelegationId || null)

      if (isAccepted && isAcceptedToday) {
        setShowSuccessModal(true)
      }
    }
  }, [localFormData, cuit])

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false)
  }

  useEffect(() => {
    if (formData) {
      setLocalFormData(formData)
    }
  }, [formData])

  useEffect(() => {
    if (formData) {
      setClientName(formData.customerSuborganizationName || "")
      setClientNote(formData.delegationNotes || "")
      setSubscriptionDelId(formData.subscriptionDelegationId || null)
    }
  }, [formData])

  const getOrganizationAccessStatus = async () => {
    setLoadingChipModule(true)
    const instances = await dispatch(
      getOrganizationAccess(client.organizationId),
    )
    if (instances && Array.isArray(instances.applicationInstances)) {
      const getInstance = instances.applicationInstances.find(
        (appInstance) =>
          appInstance.baseSuborganizationId === client.firmSuborganizationId,
      )
      const instance = await dispatch(
        getApplicationInstanceEAuthz(getInstance.applicationInstanceId),
      )
      if (instance && Array.isArray(instance.appModules)) {
        const getModule = instance.appModules.find(
          (appmodule) => appmodule.appModule === "CommunicationVE",
        )
        setisEnabledModule(
          getModule && new Date(getModule.finishDate) > new Date(),
        )
      }
    }
    setLoadingChipModule(false)
  }

  useEffect(() => {
    if (client && client.organizationId) {
      getOrganizationAccessStatus()
    }
  }, [client])

  const formatDate = (date) => {
    if (!date) return ""

    try {
      const newDate = new Date(date)

      if (isNaN(newDate.getTime())) {
        return ""
      }

      const day = newDate.getUTCDate().toString().padStart(2, "0")
      const month = (newDate.getUTCMonth() + 1).toString().padStart(2, "0")
      const year = newDate.getUTCFullYear()

      return `${day}/${month}/${year}`
    } catch (error) {
      return ""
    }
  }

  const handleSaveName = async (newName) => {
    const body = {
      subscriptionDelegationId: subscriptionDelId,
      customerSuborganizationName: newName,
    }
    await dispatch(updateSubsDelegationVE(body))
    setClientName(newName)
  }

  const handleSaveNote = async (newNote) => {
    const body = {
      subscriptionDelegationId: subscriptionDelId,
      delegationNotes: newNote,
    }
    await dispatch(updateSubsDelegationVE(body))
    setClientNote(newNote)
  }

  const getSubscriptionStatusInfo = () => {
    const status = getStatusByCode(localFormData?.subscriptionStatus)

    if (hasData && !status) {
      return {
        text: "El CUIT no está adherido al módulo de e-Ventanilla",
        className: classes.statusAmarillo,
        hasIcon: true,
        tooltip:
          "Los datos del suscriptor están en el apartado 'Estudios asociados', en el botón 'Ver suscriptores asociados.",
      }
    }

    if (status?.title) {
      return {
        text: status.title,
        className: classes.statusVerde,
        hasIcon: false,
      }
    }

    return {
      text: "El CUIT no está cargado como cliente en ningún estudio",
      className: classes.statusCoral,
      hasIcon: false,
    }
  }
  const statusInfo = getSubscriptionStatusInfo()
  if (loading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    )
  }

  const getOption = (option) => {
    switch (option) {
      case "EV":
        return (
          <div
            style={{
              display: "flex",

              alignItems: "center",
            }}
          >
            <EmailOutlinedIcon sx={{ marginRight: 1, color: "#509b92ff" }} />
            <Typography
              component="span"
              className={classes.truncatedText}
              style={{
                color: "#509b92ff",
              }}
            >
              E-ventanilla habilitado
            </Typography>
          </div>
        )
      case "NOT_EV":
        return (
          <div
            style={{
              display: "flex",

              alignItems: "center",
            }}
          >
            <ApartmentOutlinedIcon
              sx={{ marginRight: 1, color: "#b4ae40ff" }}
            />
            <Typography
              component="span"
              className={classes.truncatedText}
              style={{
                color: "#b4ae40ff",
              }}
            >
              No tiene E-ventanilla habilitado
            </Typography>
          </div>
        )
      case "NOT_CLIENT":
        return (
          <div
            style={{
              display: "flex",

              alignItems: "center",
            }}
          >
            <ReportOutlinedIcon sx={{ marginRight: 1, color: "#b25353ff" }} />
            <Typography
              component="span"
              className={classes.truncatedText}
              style={{
                color: "#b25353ff",
              }}
            >
              No es cliente en Mi Estudio
            </Typography>
          </div>
        )
      default:
        return <></>
    }
  }
  return (
    <>
      <div className={classes.root}>
        <Modal
          open={showSuccessModal}
          onClose={handleCloseSuccessModal}
          aria-labelledby="delegation-success-modal-title"
          aria-describedby="delegation-success-modal-description"
        >
          <Box sx={modalStyle}>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <CloseIcon
                sx={{
                  fontSize: "medium",
                  color: "#263057",
                  // eslint-disable-next-line comma-dangle
                  cursor: "pointer",
                }}
                onClick={handleCloseSuccessModal}
              />
            </div>
            <Typography sx={{ color: "#263057", fontSize: "1.3em" }}>
              Delegación Aceptada
            </Typography>
            <Typography
              sx={{
                color: "#263057",
                fontFamily: "Roboto",
                marginTop: "10%",
              }}
            >
              La delegación ha sido aceptada correctamente el día de hoy.
            </Typography>
            <Button
              onClick={handleCloseSuccessModal}
              variant="contained"
              className={classes.buttons}
              sx={{ backgroundColor: "#00a78f" }}
            >
              Aceptar
            </Button>
          </Box>
        </Modal>
        <BreadcrumbsComponent />
        <div className={classes.boxtitle}>
          <Typography className={classes.title}>Clientes</Typography>
        </div>
        <div className={classes.boxSubTitle}>
          <InfoIcon
            style={{ fontSize: "2rem", color: "#00a78f", marginLeft: 10 }}
          />
          <Typography className={classes.subtitle}>
            En esta sección visualizará los estudios asociados al número de
            CUIT: {cuit || ""}
          </Typography>
        </div>
        <div
          style={{
            marginTop: 40,
            paddingLeft: "5%",
            fontWeight: "bold",
            fontSize: "20px",
            color: "#4B4952",
          }}
        >
          e-Ventanilla
        </div>
        <Grid container spacing={3} className={classes.boxDetails}>
          <Grid item xs={12} md={6}>
            <EditableField
              label="Razón Social:"
              initialValue={clientName}
              onSave={handleSaveName}
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.fieldContainer}>
            <Typography
              component="span"
              className={classes.fieldLabel}
              style={{
                color: "#4B4952",
              }}
            >
              <b>Fecha de aceptación de delegación:</b>
            </Typography>
            <Typography component="span" className={classes.truncatedText}>
              {formatDate(localFormData?.accessDelegationDateTime) || ""}
              {/* {formatDate(formData?.accessDelegationDateTime) || ""} */}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6} className={classes.fieldContainer}>
            <Typography
              component="span"
              className={classes.fieldLabel}
              style={{
                color: "#4B4952",
              }}
            >
              <b>Usuario:</b>
            </Typography>
            <Typography component="span" className={classes.truncatedText}>
              {localFormData?.delegationAcceptationUser}
              {/* {formData?.delegationAcceptationUser} */}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} className={classes.fieldContainer}>
            <Typography
              component="span"
              className={classes.fieldLabel}
              style={{
                color: "#4B4952",
              }}
            >
              <b>Estado del CUIT:</b>
            </Typography>
            {getOption(
              localFormData?.hasEV
                ? "EV"
                : localFormData?.isClient
                ? "NOT_EV"
                : "NOT_CLIENT",
            )}
          </Grid>
          <Grid item xs={12} md={6}>
            <EditableField
              label="Notas:"
              initialValue={clientNote}
              onSave={handleSaveNote}
              multiline={true}
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.fieldContainer}>
            <Typography
              component="span"
              className={classes.fieldLabel}
              style={{
                color: "#4B4952",
              }}
            >
              <b>Situación en eventanilla:</b>
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "8px",
              }}
            >
              <Typography
                className={`${classes.statusBase} ${statusInfo.className}`}
              >
                {statusInfo.text}
              </Typography>

              {statusInfo.hasIcon && (
                <Tooltip title={statusInfo.tooltip}>
                  <Box
                    component="span"
                    sx={{ ml: 1, display: "flex", alignItems: "center" }}
                  >
                    <HelpOutlinedIcon
                      sx={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "#822D5E",
                        cursor: "pointer",
                      }}
                    />
                  </Box>
                </Tooltip>
              )}
            </Box>

            <AcceptDelegationButton delegationData={localFormData} />
          </Grid>
        </Grid>
        <div
          style={{
            width: "100%",
            minHeight: "calc(100vh - 16rem)",
            overflow: "auto",
            paddingBottom: "10%",
          }}
        >
          <div
            style={{
              marginTop: 30,
              paddingLeft: "5%",
              fontWeight: "bold",
              fontSize: "20px",
              color: "#4B4952",
            }}
          >
            Datos del Cliente
          </div>
          {hasData ? (
            <>
              <Grid
                container
                className={classes.boxDetails}
                key={client.customerSuborganizationCuit}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    padding: "10px 0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginLeft: "5%",
                      minWidth: "80px",
                    }}
                  >
                    <Avatar
                      src={
                        client.suborganizationBasePictureURL
                          ? `${client.suborganizationBasePictureURL}/${client.suborganizationLogoPictureURL}`
                          : null
                      }
                      sx={{
                        bgcolor: client.customerSuborganizationAvatar?.color,
                        width: 60,
                        height: 60,
                      }}
                    >
                      {client.customerSuborganizationAvatar?.initials}
                    </Avatar>
                  </div>
                  <div
                    className={classes.boxEstudioCustomer}
                    style={{
                      flex: 1,
                      paddingLeft: 20,
                      paddingRight: 20,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    {" "}
                    <Typography
                      style={{
                        fontSize: "20px",
                        color: "#4B4952",
                        paddingLeft: 10,
                      }}
                    >
                      <b>Cliente:</b> {client?.customerSuborganizationName}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "15px",
                        paddingLeft: 10,
                        color: "#4B4952",
                        marginRight: 10,
                      }}
                    >
                      <b>CUIT:</b> {client?.customerSuborganizationCuit}
                    </Typography>
                  </div>
                  <div
                    style={{
                      marginRight: "5%",
                    }}
                  >
                    <Chip
                      label={`${data?.length || 0} Estudio${
                        data?.length !== 1 ? "s" : ""
                      }`}
                      sx={{
                        backgroundColor: "#e8f5e8",
                        color: "#2e7d32",
                        fontWeight: "bold",
                        marginRight: "10%",
                      }}
                    />
                  </div>
                </div>
              </Grid>
            </>
          ) : (
            <div
              style={{
                padding: "20px",
                margin: "20px 5%",
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                textAlign: "center",
                color: "#666",
              }}
            >
              <Typography>No se encontraron datos para este cliente</Typography>
            </div>
          )}
          <div
            style={{
              marginTop: 40,
              paddingLeft: "5%",
              fontWeight: "bold",
              fontSize: "20px",
              color: "#4B4952",
            }}
          >
            Estudios Asociados
          </div>

          {hasData ? (
            data.map((suborganization, i) => (
              <Grid container className={classes.boxDetails} key={i}>
                <div className={classes.boxEstudio}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: 1,
                      width: "15%",
                    }}
                  >
                    <Avatar
                      src={
                        suborganization.suborganizationBasePictureURL
                          ? `${suborganization.suborganizationBasePictureURL}/${suborganization.firmSuborganizationLogoPictureURL}`
                          : null
                      }
                      sx={{
                        bgcolor:
                          suborganization.firmSuborganizationAvatar?.color,
                        width: 60,
                        height: 60,
                      }}
                    >
                      {suborganization.firmSuborganizationAvatar?.initials}
                    </Avatar>
                  </div>
                  <div
                    style={{
                      fontSize: "17px",
                      marginBottom: 5,
                      display: "flex",
                      flexDirection: "column",
                      width: "35%",
                      color: "#4B4952",
                    }}
                  >
                    <div style={{ marginBottom: "5px" }}>
                      <b>Organización Asociada:</b>{" "}
                      {suborganization.organizationName}
                    </div>
                    <div>
                      <b>CUIT Organización: </b>
                      {suborganization.organizationCuit}
                    </div>
                    <div
                      style={{
                        paddingTop: "1rem",
                      }}
                    >
                      <Chip
                        label={`Ver suscriptores asociados`}
                        sx={{
                          backgroundColor: "#e8f5e8",
                          color: "#2e7d32",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                        onClick={() =>
                          navigate(
                            `/organizations/${suborganization.organizationId}/subscribers`,
                          )
                        }
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignContent: "center",

                      fontSize: "15px",
                      color: "#4B4952",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "17px",
                        marginBottom: 5,
                        display: "flex",
                        flexDirection: "column",
                        width: "400px",
                        borderLeft: "2px solid #E0E0E0",
                        paddingLeft: "5%",
                      }}
                    >
                      <div style={{ marginBottom: "5px" }}>
                        <b>Estudio: </b>
                        {suborganization.firmSuborganizationName}
                      </div>
                      <div>
                        {" "}
                        <b>CUIT Estudio:</b>{" "}
                        {suborganization.firmSuborganizationCuit}
                      </div>
                      <div
                        style={{
                          paddingTop: "1rem",
                        }}
                      >
                        <Chip
                          label={
                            loadingChipModule
                              ? ""
                              : `Módulo E-ventanilla ${
                                  isEnabledModule
                                    ? "habilitado"
                                    : "no habilitado"
                                }`
                          }
                          sx={{
                            backgroundColor: "#dfdfdfff",
                            color: isEnabledModule ? "#3a3939ff" : "#b32c2cff",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                          icon={
                            loadingChipModule ? (
                              <CircularProgress color="inherit" size={"16px"} />
                            ) : isEnabledModule ? (
                              <DoneAllIcon
                                sx={{ color: "#393a39ff !important" }}
                              />
                            ) : (
                              <ErrorOutlineIcon
                                sx={{
                                  color: "#b32c2cff !important",
                                }}
                              />
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            ))
          ) : (
            <div
              style={{
                padding: "20px",
                margin: "20px 5%",
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                textAlign: "center",
                color: "#666",
              }}
            >
              <Typography>No se encontraron estudios asociados</Typography>
            </div>
          )}

          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginTop: 40,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              gap: 40,
            }}
          >
            <button
              onClick={() => navigate("/ME/eventanilla")}
              style={{
                backgroundColor: "#00a78f",
                color: "white",
                padding: "10px 20px",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              Ir a Clientes Asociados
            </button>

            <button
              onClick={() => navigate("/ME/eventanilla/loadedClients")}
              style={{
                backgroundColor: "#00a78f",
                color: "white",
                padding: "10px 20px",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              Ir al listado de CUITs aceptados en ARCA
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
